import { AttributeSelections } from 'bundles/enterprise-admin-users/types';

export const expandAttributes = (attributeSelection: AttributeSelections[]) =>
  attributeSelection.reduce((selection, attribute) => {
    if (attribute === AttributeSelections.businessUnits) {
      return [...selection, 'BUSINESS_UNIT', 'BUSINESS_UNIT_2'];
    }
    if (attribute === AttributeSelections.manager) {
      return [...selection, 'MANAGER_NAME', 'MANAGER_EMAIL'];
    }
    if (attribute === AttributeSelections.location) {
      return [...selection, 'LOCATION_COUNTRY', 'LOCATION_REGION', 'LOCATION_CITY'];
    }
    return [...selection, attribute];
  }, [] as string[]);
